var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partnerCode==='ultimate_tz' || _vm.partnerCode==='two_tz')?_c('UltimateTz'):_c('Default')}
var staticRenderFns = []

export { render, staticRenderFns }